<div class="preguntas-frecuentes-container">
    <h2>{{titulo}}</h2>

    <div class="faqs">
        <div *ngFor="let item of preguntasFrecuentes" class="faq-item">
            <div class="faq-question" (click)="toggleQuestion(item.question)">
                {{ item.question }}
                <span class="arrow">
                    {{ expandedQuestion === item.question ? '▲' : '▼' }}
                </span>
            </div>
            <div class="faq-answer" *ngIf="expandedQuestion === item.question">
                {{ item.answer }}
            </div>
        </div>
    </div>
</div>